import type { Routes } from '@angular/router';

export const CREDENTIALS_ROUTES: Routes = [
    {
        path: 'validate',
        loadComponent: () =>
            import('#core/credentials/views/validate-credentials/validate-credentials.component').then(
                (m) => m.ValidateCredentialsComponent
            ),
    },
    {
        path: 'missing_organization',
        loadComponent: () =>
            import('#core/credentials/views/missing-organization/missing-organization.component').then(
                (m) => m.MissingOrganizationComponent
            ),
    },
];
